export default __webpack_public_path__ + "4f22b07ee5d766570543d2007498cc25.png";